var React = require('react');

function WavesInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"gentle-wave","d":"M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"})),React.createElement("g",{"className":"parallax","key":1},[React.createElement("use",{"xlinkHref":"#gentle-wave","x":"48","y":"0","fill":"rgba(255,255,255,0.7","key":0}),React.createElement("use",{"xlinkHref":"#gentle-wave","x":"48","y":"3","fill":"rgba(255,255,255,0.5)","key":1}),React.createElement("use",{"xlinkHref":"#gentle-wave","x":"48","y":"5","fill":"rgba(255,255,255,0.3)","key":2}),React.createElement("use",{"xlinkHref":"#gentle-wave","x":"48","y":"7","fill":"#fff","key":3})])]);
}

WavesInline.defaultProps = {"className":"waves","viewBox":"0 24 150 28","preserveAspectRatio":"none","shapeRendering":"auto"};

module.exports = WavesInline;

WavesInline.default = WavesInline;
